module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    class: ['vc-image-placeholder'],
    attrs: {
      "src": _vm.src,
      "width": _vm.width,
      "height": _vm.height,
      "title": _vm.title,
      "alt": _vm.title
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c39f9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-image-placeholder/vc-image-placeholder.vue
// module id = 45
// module chunks = 0